define('rebrush/main',[
	'require',
	'lodash',
	'jquery',
	'cartware/components/Config',
	'cartware/components/Registry',
	'cartware/components/Dispatcher',
	'cartware/components/FeatureFlags',
	'cartware/components/Utilities',
	'cartware/components/Logger',
	'cartware/components/PubSubHub',
	'json!./handles/default.json',
	'rebrush/system/validation',
	'gigaset/spinner',
	'cartware-slider',
	'grunticon-loader',
	'magnific-popup',
	'frame-manager',
], function(
	require,
	_,
	$,
	Config,
	Registry,
	ComponentDispatcher,
	FeatureFlags,
	Utils,
	Logger,
	PubSubHub,
	Handles,
	Spinner
) {
	var gruntIconLastChange = 1638536463;

	grunticon([
		require.toUrl('skin/frontend/gigaset/rebrush/icons/dist/icons.data.svg.css?t=' + gruntIconLastChange),
		require.toUrl('skin/frontend/gigaset/rebrush/icons/dist/icons.data.png.css?t=' + gruntIconLastChange),
		require.toUrl('skin/frontend/gigaset/rebrush/icons/dist/icons.fallback.css?t=' + gruntIconLastChange)
	]);

	// Magnific Popup default values
	$.extend(true, $.magnificPopup.defaults, {
		fixedContentPos: false,
		fixedBgPos: true,
		overflowY: 'auto',
		closeBtnInside: true,
		preloader: false,
		midClick: true,
		removalDelay: 300,
		mainClass: 'gigaset-mfp-slide-bottom'	// slide in fx; alternative is gigaset-mfp-zoom-in
	});

	return {
		dispatcher: null,
		featureFlags: null,

		bootstrap: function() {
			Config.populate(window.gigaset || {});

			this.dispatcher = new ComponentDispatcher({
				handles: Utils.getPath(window, 'gigaset.handles') || []
			});

			this.bootstrapDispatcher();

			this.featureFlags = new FeatureFlags(Utils.getPath(window, 'gigaset.featureflags') || {});

			var developerMode = this.featureFlags.isEnabled('developer_mode');

			if (developerMode) {
				require(['mgt_developertoolbar']);
			}

			Logger.setDefaultLevel(developerMode ? Logger.levels.DEBUG : Logger.levels.ERROR);

			_.set(window, 'gigaset.debug.logger', Logger);

			Registry().register('featureFlags', this.featureFlags);
			Registry().register('system.dispatcher', this.dispatcher);
		},

		bootstrapDispatcher: function() {
			var self = this;

			Registry().register('component.dispatcher', this.dispatcher);

			_.forEach(Handles, function(components, handle) {
				require(components, function() {
					var handleMapApply = {};
					handleMapApply[handle] = Array.prototype.slice.call(arguments, 0);

					self.dispatcher.applyHandles(handleMapApply);
				});
			});
		}
	}
});

define('rebrush', ['rebrush/main'], function (main) { return main; });

